import PanelEditorHeader from './PanelEditorHeader';

export default PanelEditorHeader;
